import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import {TILL_IMAGE, WEB_MENU_SMALL_IMAGE} from "../../shared/utils/Constants";
import ProductTagColumn from "../../shared/component/dataTable/columns/ProductTagColumn.json";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import {FileUpload} from "primereact/fileupload";
import {Button as ButtonSearch} from "primereact/components/button/Button";
import TagService from "../../shared/service/TagService";
import {ColorPicker} from 'primereact/colorpicker';
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import '../../shared/styles/SettingsPage.css';
import '../../shared/styles/MasterDetailSave.css';
import FormSection from '../../shared/component/form/FormSection';

const defaultProductTag = {
    id: '',
    name: '',
    status: 'ACTIVE',
    fileType: '',
    fileName: 'Choose',
    shortName: '',
    tagColor: null
};
export default class ProductTagSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productTag: defaultProductTag,
            productTagTemp: defaultProductTag,
            productTagDetailsSaveButtonRender: true,
            defaultStatus: 'ACTIVE',
            taxList: [],
            productTagList: []
        }
        this.productTagService = new TagService();
    }

    componentDidMount() {
        let obj1 = Object.assign({}, defaultProductTag);
        this.setState({
            productTag: obj1, productTagDetailsSaveButtonRender: false, productTagTemp: Object.assign({}, obj1)
        });

        this.refresh();
    }

    refresh() {
        this.productTagService.findAll().then(response => this.setState({
            productTagList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.productTagDetails()}
                    </div>
                </AvForm>
            </div>
        );
    }

    showChangeStatusConfirmDialog = (value) => {
        let defaultStatus = 'PASSIVE';
        if (value) {
            defaultStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            defaultStatus: defaultStatus,
            noticeResponse: "You are about to change the status. Are you sure?"
        });
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.productTag.id)) {
            this.productTagService.delete(this.state.productTag.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let obj1 = Object.assign({}, defaultProductTag);
                        this.setState({
                            productTag: obj1, productTagDetailsSaveButtonRender: false,
                            productTagTemp: Object.assign({}, obj1)
                        });
                        this.refresh();
                    }
                });
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        let defaultStatus = 'PASSIVE';
        if (value) {
            defaultStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            defaultStatus: defaultStatus,
            noticeResponse: "Are you sure to delete?"
        });
    }

    productTagDetails() {
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Product Tag</h1>
                </div>

                <div className="settings-page__panel master-detail-save">
                    <ModalConfirm header='Warning' ok='OK' onOkClick={this.delete}
                                  onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                  show={this.state.displayShowStatusConfirmDialog}
                                  message={this.state.noticeResponse}/>

                    <div className="master-detail-save__split">
                        <div className="master-detail-save__list">
                            <FormSection title="Product Tags" className="master-detail-save__list-section">
                                {GeneralUtils.checkPrivilege("post_product/tag") &&
                                    <div className="settings-page__toolbar settings-page__toolbar--start master-detail-save__list-toolbar">
                                        <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                                            this.addNew();
                                        }}>
                                            <Translate contentKey="entity.action.add">Add</Translate>
                                        </Button>
                                    </div>}
                                {GeneralUtils.checkPrivilege("get_product/tag") &&
                                    <div className="settings-page__table-wrap master-detail-save__list-table">
                                        <DataTableWithButton ref={(elem) => this.refDataTable = elem} fields={ProductTagColumn.fields}
                                                     objectName={ProductTagColumn.name}
                                                     data={this.state.productTagList}
                                                     rows={10}
                                                     selectionMode="single" onDataSelect={this.onDataSelect}
                                                     loading={this.state.loading}/>
                                    </div>}
                            </FormSection>
                        </div>

                        <div className="master-detail-save__details">
                            <div className="master-detail-save__details-body">
                                <FormSection title="Product Tag Details">
                        <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__filter-row--wide settings-page__form-fields">
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="product-tag-name">
                                        <Translate contentKey="productTag.tradingName">Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        id="product-tag-name"
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        disabled={!this.state.productTagDetailsSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.productTag.name}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="product-tag-short-name">
                                        <Translate contentKey="productTag.tradingName">Short Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        id="product-tag-short-name"
                                        type="text"
                                        className="form-control"
                                        name="shortName"
                                        disabled={!this.state.productTagDetailsSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.productTag.shortName}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="product-tag-color">
                                        <Translate contentKey="productTag.tradingName">Tag Color</Translate>
                                    </Label>
                                    <ColorPicker value={this.state.productTag.tagColor}
                                                 format="hex"
                                                 name="tagColor"
                                                 onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                            <div className="settings-page__filter-field">
                                <Label>Product Tag Image</Label>
                                <div className="settings-page__actions settings-page__actions--inline">
                                    <FileUpload name="demo"
                                                accept="image/*"
                                                maxFileSize={50000}
                                                onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                                                invalidFileSizeMessageDetail="Maximum upload size is 50K."
                                                chooseLabel={this.state.productTag.fileName == null ? "Choose" : this.state.productTag.fileName}
                                                disabled={!this.state.productTagDetailsSaveButtonRender}
                                                ref={elem => this.refUploadInputImage = elem}
                                                mode="basic"/>
                                    <ButtonSearch icon="pi pi-search" onClick={() => {
                                        try {
                                            GeneralUtils.previewDocument(this.refUploadInputImage);
                                        } catch (e) {
                                            this.downloadDocument();
                                        }
                                    }}/>
                                    <ButtonSearch icon="pi pi-minus"
                                                  disabled={!this.state.productTagDetailsSaveButtonRender}
                                                  onClick={() => this.removeDocument(TILL_IMAGE)}/>
                                </div>
                            </div>
                        </div>

                        <div className="settings-page__actions master-detail-save__form-actions">
                            {GeneralUtils.checkPrivilege("post_product/tag") && this.state.productTagDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.productTag.id) &&
                                <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                    this.setState({productTagDetailsSaveButtonRender: true});
                                }}>
                                    <Translate contentKey="entity.action.add">Edit</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("post_product/tag") && this.state.productTagDetailsSaveButtonRender &&
                                <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                    this.saveProductTag();
                                }}>
                                    <Translate contentKey="entity.action.add">Save</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("delete_product/tag/_id") && this.state.productTagDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.productTag.id) &&
                                <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                    this.showChangeStatusConfirmDialog(true);
                                }}>
                                    <Translate contentKey="entity.action.add">Delete</Translate>
                                </Button>}
                            {GeneralUtils.checkPrivilege("post_product/tag") && this.state.productTagDetailsSaveButtonRender &&
                                <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                    let obj1 = this.state.productTagTemp;
                                    this.setState({
                                        productTag: Object.assign({}, obj1), productTagDetailsSaveButtonRender: false
                                    });
                                }}>
                                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                </Button>}
                        </div>
                                </FormSection>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    onDataSelect = (data) => {
            this.productTagService.findById(data.id).then(response => {
                if (data.id < 0) {
                    this.setState({
                        productTag: response,
                        productTagDetailsSaveButtonRender: null,
                        productTagTemp: Object.assign({}, response)
                    });
                } else {
                    this.setState({
                        productTag: response,
                        productTagDetailsSaveButtonRender: false,
                        productTagTemp: Object.assign({}, response)
                    });
                }


            });


    }

    removeDocument(type) {
        if (!GeneralUtils.isNullOrEmpty(this.state.productTag.id)) {
            this.productTagService.removeDocument(this.state.productTag.id, type).then(response => {
                this.setState({
                    productTagDetailsSaveButtonRender: false,
                    productTag: response,
                })
            });
        } else {
            this.refUploadInputImage.clear();

        }

    }

    downloadDocument = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.productTag.id)) {
            this.productTagService.downloadDocument(this.state.productTag.id, WEB_MENU_SMALL_IMAGE).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response.file)) {
                    GeneralUtils.convertToDownloadableFile(response);
                }

            });
        }

    }
    saveProductTag = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.productTag.name) || GeneralUtils.isNullOrEmpty(this.state.productTag.shortName)) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.productTag.id)) {
                this.productTagService.update(this.state.productTag)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                productTagDetailsSaveButtonRender: false,
                                productTag: response,
                                productTagTemp: Object.assign({}, response)
                            });
                            this.uploadDocument(response.id);
                            this.refresh();
                        }
                    });
            } else {
                this.productTagService.create(this.state.productTag)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                productTagDetailsSaveButtonRender: false,
                                productTag: response,
                                productTagTemp: Object.assign({}, response)
                            });
                            this.uploadDocument(response.id);
                            this.refresh();
                        }
                    });
            }
        }

    }


    uploadDocument(id) {
        let image = this.refUploadInputImage.files;
        if (!(GeneralUtils.isNullOrEmpty(image) || GeneralUtils.isNullOrEmpty(image.length))) {
            let formData = new FormData();
            if (!GeneralUtils.isNullOrEmpty(image) && !GeneralUtils.isNullOrEmpty(image.length)) {
                formData.append("file", image[0]);
                this.productTagService.uploadDocument(id, formData, WEB_MENU_SMALL_IMAGE).then(response => {
                    this.setState({
                        productTagDetailsSaveButtonRender: false
                    })
                });
            }
        }
    }

    addNew() {
        let obj1 = Object.assign({}, defaultProductTag);
        this.setState({
            productTag: obj1, productTagDetailsSaveButtonRender: true, productTagTemp: Object.assign({}, obj1)
        });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let productTag = this.state.productTag;
        productTag[e.target.name] = value;
        this.setState({productTag: productTag});
    }

}

